import {mapGetters} from 'vuex';

// Computed
const computed = {
  ...mapGetters ('consumer', {
    hasGroupTicketPurchased: 'hasGroupTicketPurchased',
    hasGroupTicketPaymentInProcess : 'hasGroupTicketPaymentInProcess',
  }),
};

// Methods
const paymentActionClassifier = {
  methods:{
    _moduleWithAction(){
      switch (this.event_type) {
          case this.DEFINES.SCREENER_TYPE_VALUE.VIRTUAL:
              return "consumer/purchaseScreeningOrGroupTicket";
          case this.DEFINES.SCREENER_TYPE_VALUE.PHYSICAL:
              return "bookings/bookSeats";
          case this.DEFINES.SCREENER_TYPE_VALUE.SUBSCRIPTION:
              return "subscription/create"; /* In case of subscription system */
          default:
            return;
      }
    },
  }
};

const hasGroupTicketPurchased = {
  computed: computed,
};

const hasGroupTicketPaymentInProcess = {
  computed: computed,
};

export {hasGroupTicketPurchased,paymentActionClassifier, hasGroupTicketPaymentInProcess};
